import * as d3 from 'd3'
export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      let sql1 = JSON.parse(JSON.stringify(this.Queries.SQL1[0]))
      this.cutoff = sql1.CUTOFF
      this.punch = sql1.PUNCH



      let json = JSON.parse(JSON.stringify(this.JQueries))

      //##### JSON #####
      this.title       = json.title
      this.timeline    = json.timeline
      this.primary     = json.primary
      this.secondary   = json.secondary
      this.chart       = json.chart
      this.legends     = json.legends
      this.summary     = json.summary
      this.keys        = json.keys
      this.filters     = json.filters
      this.sundries    = json.sundries

      this.legends.y = this.chart.y + this.chart.height + 25

      this.slide = {sn: 0, x: 0}
      

      let cx = 70
      let result = [ ...new Set(this.rawData.map(d => d.DISC)) ]
      this.chartList = []
      
      result.forEach((d,i)=> {
        this.chartList.push({
          idx: i,
          cx: cx,
          cy: this.chart.y,
          disc: d, 
          name: this.rawData.find(f=> f.DISC == d).DISC_DESC,
          dataSet: this.rawData.filter(f=> f.DISC == d),
          thisWeek: this.rawData.find(f=> f.DISC == d && f.CDATE == this.cutoff)
        })
        cx += this.chart.width + 70
      })
      
      // this.gmx_tableCoordinates('x', this.summary.status, 0)
      // this.summary.width = this.summary.status[this.summary.status.length-1].ex
    },

  }
}